<template>
    <tr :class="`${isDeleteRequested || isEditRequested ? 'edit-row' : ''}`">
        <td>
            <EmptyTextHandler :text="PalServiceLocationsEnum.getDescriptionUsingValue(service.Code)" />
        </td>
        <td>
            <EmptyTextHandler :text="formatDate(service.Start)" />
        </td>
        <td>
            <EmptyTextHandler :text="service.StartTime" />
        </td>
        <td class="text-end" v-if="!isDeleteRequested">
            <button
                type="button"
                class="btn table-btn btn-outline-info"
                v-if="!isEditRequested"
                v-tooltip="{ title: 'Edit service location' }"
                @click="openEditServiceLocation()"
            >
                <i class="fas fa-edit"></i>
            </button>
            <button
                type="button"
                class="btn table-btn btn-outline-danger"
                v-if="!isEditRequested && itemCount > 1"
                v-tooltip="{ title: 'Delete service location' }"
                @click="confirmDeleteService()"
            >
                <i class="fas fa-trash-alt"></i>
            </button>
            <i v-if="isEditRequested">Edit In Progress</i>
        </td>
        <td colspan="1" v-if="isDeleteRequested">
            <TablePrompt
                ok-text="delete"
                :is-in-progress="isDeleteInProgress"
                :ok="deleteServiceLocation"
                :cancel="cancelDeleteService"
            />
        </td>
    </tr>
    <tr v-if="isEditRequested" class="edit-row">
        <td :colspan="columns">
            <AddServiceLocationForm
                :service="service"
                :reset-list="resetList"
                :closeEditService="closeEditService"
                :openEditServiceLocation="openEditServiceLocation"
                :isEdit="isEditRequested"
            />
        </td>
    </tr>
</template>

<script src="./ServiceLocationRow.ts"></script>
